import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import getApiData from "../../../../hooks/apiRequests/getRequest";
import { normalizePageParam } from "../../../../hooks/pagination";
import TablePageSelect from "../../../shared/table/tablePageSelect";

import {
  Typography,
  Box,
  TextField,
  InputAdornment,
  Stack,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AuditTable from "./table/auditTable";

const UserAudits = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [auditList, setAuditList] = useState({ data: [], page: {} });
  const [progress, setProgress] = useState(false);
  const [searchInput, setSearchInput] = useState(searchParams.get("query") || "");

  const query = searchParams.get("query") || "";
  const page = normalizePageParam(searchParams.get("page"));

  useEffect(() => {
    setSearchInput(query);
  }, [query]);

  useEffect(() => {
    const fetchData = async () => {
      setProgress(true);
      try {
        const response = await getApiData(
          `/Audit/List?Search_filter=${encodeURIComponent(query)}&page_number=${page}`
        );
        const payload = response?.data;
        if (payload && Array.isArray(payload.data)) {
          setAuditList(payload);
        } else if (Array.isArray(payload)) {
          setAuditList({ data: payload, page: {} });
        } else {
          setAuditList({ data: [], page: {} });
        }
      } catch (error) {
        console.error("Error fetching audit data:", error);
        setAuditList({ data: [], page: {} });
      } finally {
        setProgress(false);
      }
    };
    fetchData();
  }, [query, page]);

  const newpage = async (nextPage, search = query) => {
    setSearchParams({
      query: search || "",
      page: normalizePageParam(nextPage),
    });
  };

  const submitSearch = () => {
    setSearchParams({
      query: searchInput.trim(),
      page: "1",
    });
  };

  return (
    <Box sx={{ px: { xs: 1, md: 2 }, pb: 3 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        spacing={1.5}
        sx={{ py: 2 }}
      >
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: "black" }}>
            User Audits
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Newest activity first. 10 records per page.
          </Typography>
        </Box>

        <TextField
          size="small"
          placeholder="Search actions or user id"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") submitSearch();
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" color="action" />
              </InputAdornment>
            ),
          }}
          sx={{ minWidth: { xs: "100%", sm: 280 } }}
        />
      </Stack>

      <Paper
        elevation={0}
        sx={{
          bgcolor: "#fff",
          borderRadius: "15px",
          boxShadow: "1px 5px 5px 1px rgba(0,0,0,0.12)",
          p: { xs: 1.5, md: 2 },
        }}
      >
        <AuditTable auditList={auditList} progress={progress} />
        <TablePageSelect
          data={auditList}
          page={page}
          newpage={(nextPage) => newpage(nextPage, query)}
        />
      </Paper>
    </Box>
  );
};

export default UserAudits;
